import { http } from './client';
import type { OrgSummary, UserProfile } from './types';

export const meApi = {
  async profile(): Promise<UserProfile> {
    const res = await http.get<UserProfile>('/v1/me');
    return res.data;
  },
  async orgs(): Promise<{ items: OrgSummary[] }> {
    const res = await http.get<{ items: OrgSummary[] }>('/v1/me/orgs');
    return res.data;
  },
};
